/**
 * The Property Setup module's API paths.
 *
 * These sit outside `createResourceModule` because setup is not a CRUD list:
 * one GET/PUT per property, plus the gateway vocabularies it needs.
 */
export const propertySetupEndpoints = {
  properties: '/v1/properties',
  setup: (propertyId: string): string => `/v1/properties/${propertyId}/setup`,
  gateways: (propertyId: string): string => `/v1/properties/${propertyId}/setup/gateways`,
} as const;
